import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const { user } = useAuth();
  const [sites, setSites] = useState([]);
  const [siteId, setSiteId] = useState(localStorage.getItem("eps_site"));
  const [loaded, setLoaded] = useState(false);

  const apply = (list) => {
    setSites(list);
    const cur = list.find((s) => s.id === localStorage.getItem("eps_site")) || list[0];
    if (cur) localStorage.setItem("eps_site", cur.id);
    else localStorage.removeItem("eps_site");
    setSiteId(cur?.id || null);
    setLoaded(true);
  };

  const reload = useCallback(async () => {
    try {
      const r = await api.get("/sites");
      localStorage.setItem("eps_sites", JSON.stringify(r.data));
      apply(r.data);
    } catch {
      apply(JSON.parse(localStorage.getItem("eps_sites") || "[]"));
    }
  }, []);

  useEffect(() => {
    if (user) reload();
  }, [user, reload]);

  const select = (id) => {
    localStorage.setItem("eps_site", id);
    setSiteId(id);
  };
  const site = sites.find((s) => s.id === siteId) || null;
  return <SiteCtx.Provider value={{ sites, site, select, reload, loaded }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);

export const SiteSelector = () => {
  const { sites, site, select } = useSite();
  if (!sites.length) return null;
  return (
    <select value={site?.id || ""} onChange={(e) => select(e.target.value)} data-testid="site-selector"
      className="h-11 max-w-[150px] truncate rounded-md border border-slate-700 bg-slate-900 px-2 text-sm font-semibold text-slate-100 focus:outline-none focus:ring-2 focus:ring-rose-500/60 sm:max-w-[260px]">
      {sites.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
    </select>
  );
};
